import React from 'react';

/**
 * Shared equal-height card for linked projects, rulesets, and features.
 * Title stays fixed; the body always shows a vertical scrollbar.
 */
export default function LinkedItemsCard({ icon, title, count, children }) {
    return (
        <div style={{
            background: 'var(--bg-card)',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius)',
            padding: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            flex: 1,
            minHeight: 0,
            overflow: 'hidden'
        }}>
            <h3 style={{
                fontSize: '0.95rem',
                fontWeight: 700,
                margin: 0,
                color: 'var(--text-primary)',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                flexShrink: 0
            }}>
                <i className={icon} style={{ color: 'var(--accent)' }}></i>
                {title}
                <span style={{
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: 'var(--text-secondary)',
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border)',
                    borderRadius: '999px',
                    padding: '0.1rem 0.5rem'
                }}>
                    {count}
                </span>
            </h3>
            <div style={{
                flex: 1,
                minHeight: 0,
                overflowY: 'scroll'
            }}>
                {children}
            </div>
        </div>
    );
}
